import { render, staticRenderFns } from "./newCode.vue?vue&type=template&id=3167b47c&scoped=true"
import script from "./newCode.vue?vue&type=script&lang=js"
export * from "./newCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3167b47c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3167b47c')) {
      api.createRecord('3167b47c', component.options)
    } else {
      api.reload('3167b47c', component.options)
    }
    module.hot.accept("./newCode.vue?vue&type=template&id=3167b47c&scoped=true", function () {
      api.rerender('3167b47c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/sendDriverInvitationCode/component/newCode.vue"
export default component.exports